<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QCJ8Rl/media/FC-9781528935258.jpg?1708093998536" alt="This image is the cover for the book Eight Miles High"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Eight Miles High
      </h1>
      <p class="bookDescription body article font2">
        <p>The story begins in the womb. Our heroine is born into a very happy life with adoring parents who she comes to love deeply. Then, tragically, she becomes an orphan when her beloved parents are killed in an air crash. She has to go into an orphanage and then a foster home and at long last she is adopted by a lovely couple but she can never love them. She wants to be an actress and eventually ends up in Los Angeles. At the age of twenty-one she inherits a fortune from her parents. She marries a man who she thinks is her dream. But is he her dream or is there another agenda at play?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nicholson
      </h2>
      
      <p class="authorDescription body article">Nicholson left international finance at the age of 46 with enough money to start travelling the world for fun. He published his first book in 2017, Mr Tambourine Man, written from his dreams detailing his adventures. He then went on to write two novels, The Tell-tale and My Back Pages. He has lived happily in Cornwall for the last twenty-three years with his loving wife of 42 years, Chrissie, and has a 33-year-old daughter, Lauren, whom he adores.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1f960ab8